module.exports = __webpack_public_path__ + "static/img/template_img_04.a1499ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/template_img_04.jpg
// module id = 395
// module chunks = 0